/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSubscriptionPhase
 */
export interface UserSubscriptionPhase {
    /**
     * Unix seconds
     * @type {number}
     * @memberof UserSubscriptionPhase
     */
    startDate: number;
    /**
     * Unix seconds
     * @type {number}
     * @memberof UserSubscriptionPhase
     */
    endDate: number;
    /**
     * Stripe price id billed in this phase
     * @type {string}
     * @memberof UserSubscriptionPhase
     */
    priceId?: string;
}

/**
 * Check if a given object implements the UserSubscriptionPhase interface.
 */
export function instanceOfUserSubscriptionPhase(value: object): value is UserSubscriptionPhase {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function UserSubscriptionPhaseFromJSON(json: any): UserSubscriptionPhase {
    return UserSubscriptionPhaseFromJSONTyped(json, false);
}

export function UserSubscriptionPhaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSubscriptionPhase {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'priceId': json['priceId'] == null ? undefined : json['priceId'],
    };
}

export function UserSubscriptionPhaseToJSON(json: any): UserSubscriptionPhase {
    return UserSubscriptionPhaseToJSONTyped(json, false);
}

export function UserSubscriptionPhaseToJSONTyped(value?: UserSubscriptionPhase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'priceId': value['priceId'],
    };
}

